import React from "react";
import { CheckCircle2 } from "lucide-react";

import LogicAppFlowCanvas from "./LogicAppFlowCanvas";

import type { FlowStep } from "../types";

type Props = {
  flowSteps: FlowStep[];
  selectedStepId: string;
  setSelectedStepId: (value: string) => void;

  addBlock: (block: string) => void;

  openMapper: () => void;
  openPayloadEditor: () => void;

  payloadIsValid: boolean;
  payloadVariableCount: number;
  missingRequiredCount: number;
};

export default function FlowBuilderMain({
  flowSteps,
  selectedStepId,
  setSelectedStepId,
  addBlock,
  openMapper,
  openPayloadEditor,
  payloadIsValid,
  payloadVariableCount,
  missingRequiredCount,
}: Props) {
  return (
    <main className="flex-1 overflow-y-auto bg-slate-50 p-6 dark:bg-slate-950">
      <div className="mb-6 flex items-center justify-between gap-4">
        <div>
          <h2 className="text-2xl font-black text-slate-950 dark:text-white">
            Flow Orchestration
          </h2>

          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
            Workflow runtime, payload mapping en integration orchestration.
          </p>
        </div>

        <div className="flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-4 py-2 text-sm font-semibold text-emerald-700 dark:border-emerald-500/30 dark:bg-emerald-500/10 dark:text-emerald-300">
          <CheckCircle2 className="h-4 w-4" />
          Runtime Ready
        </div>
      </div>

      <div className="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm dark:border-white/10 dark:bg-slate-900/70">
        <LogicAppFlowCanvas
          flowSteps={flowSteps}
          selectedStepId={selectedStepId}
          setSelectedStepId={setSelectedStepId}
          addBlock={addBlock}
          openMapper={openMapper}
          openPayloadEditor={openPayloadEditor}
          payloadIsValid={payloadIsValid}
          payloadVariableCount={payloadVariableCount}
          missingRequiredCount={missingRequiredCount}
        />
      </div>
    </main>
  );
}